import { useEffect, useState } from "react";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { ScorecardVA, filterColumnValues } from "../../../Component/Model/Dto/ScorecardLicense";
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { CoreStaticDataService } from "../../../Component/Api/StaticData/CoreStaticDataService";
import { UserService } from "../../../Component/Api/User/UserService";
import { defaultObject } from "../../../Component/Model/helpers";
import { FilterType, IFilter } from "../../../Component/Common/Components/DataTable/Filters";
import { BEEScorecardService } from "../../../Component/Api/BEEScorecard/BEEScorecard";
import { VAScorecardTableMapper } from "./VAScorecardsTableMapper";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { Dialog, DialogContent } from "@mui/material";
import { ConfirmationDialog } from "../../../Component/Common/Components/ConfirmationDialog";
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { toast } from "react-toastify";
import { VAClientCertificateModal } from "../Scorecards/CertificatesModal";
import { ScorecardVerificationProcessTracker } from "../../BEEScorecards/ScorecardLicenses/ScorecardVerificationProcessTracker";
import { ScorecardLicenseModal } from "../../BEEScorecards/ScorecardLicenses/ScorecardLicenseModal/ScorecardLicenseModal";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userRolesState } from "../../../State/user.Atom";
import { ScorecardAdmin, UserAdminRole } from "../../../Component/Common/Constants/UserRoles";
import {AssignModal} from "../../BEEScorecards/AssignModal";
import { BBBEEScorecardAtom } from "../../../State/BBBEEScorecard.Atom";
import { useHistory } from "react-router-dom";

export const OpenScorecardsPage = () => {
  const userRoles = useRecoilValue(userRolesState);
  const [openScorecardsData, setOpenScorecardData] = useState<ScorecardVA.ScorecardDataCore[]>(defaultObject);
  const [isLoading, setIsLoading] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
  const [userNames, setUserNames] = useState<filterColumnValues[]>(defaultObject);
  const [beeScorecardType, setBeeScorecardType] = useState<filterColumnValues[]>(defaultObject);
  const [yearsRange, setYearsRange] = useState<filterColumnValues[]>(defaultObject);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState<boolean>(false);
  const [showLockConfirmationDialog, setShowLockConfirmationDialog] = useState<boolean>(false);
  const [selectedScorecardId, setSelectedScorecardId] = useState<string>("");
  const [showViewCertificatesModal, setShowViewCertificatesModal] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [showVaModal, setVaShowModal] = useState<boolean>(false);
  const [showVAAssignModal, setShowVaAssignModal] = useState<boolean>(false);
  const [showStatusTracker, setShowStatusTracker] = useState<boolean>(false);

  const setBBBEEScorecard = useSetRecoilState(BBBEEScorecardAtom);
  const history = useHistory();

  const [filters, setFilters] = useState({});

  const getUsers = async () => {
    try {
      const users = await UserService.getNonAdminUsers();
      setUserNames(users.data.map((data) => {
        return { key: data.username, val: data.username };
      })
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getScorecardType = async () => {
    try {
      const scorecardType = await CoreStaticDataService.getBeeScorecardType();
      setBeeScorecardType(scorecardType.data.map((data: any) => {
        return { key: data.name, val: data.id };
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getYearsRange = () => {
    const now = new Date();
    const year10YearsAgo = now.getFullYear() - 10;
    const nextYear = now.getFullYear() + 2;
    const rangeOfYears = Array.from(
      { length: nextYear - year10YearsAgo },
      (_, i) => year10YearsAgo + i
    );
    setYearsRange(rangeOfYears.map((data) => {
      return { key: data.toString(), val: data };
    })
    );
  };

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions([sortOption])
    setPageNumber(1);
  };

  const searchValueChanged = (searchValue: string) => {
    setSearchValue(searchValue);
  };

  const handleCloseDeleteConfirmation = () => {
    setShowDeleteConfirmationDialog(false);
    setSelectedScorecardId("");
  }

  const handleDelete = async () => {
    try {
      await BEEScorecardService.deleteCoreScorecard(selectedScorecardId);
      toast.success("Successfully deleted scorecard");
      searchScorecardData();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseDeleteConfirmation();
    }
  };

  const searchScorecardData = async () => {
    setIsLoading(true);
    try {
      let scorecardSearchRequestCore: ScorecardVA.ScorecardSearchRequestCoreVA = {
        columnSortOptions: columnSortOptions,
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        years: [],
        scorecardTypeIds: [],
        createdByUserNames: [],
        onlySearchLockedScorecards: false
      };

      scorecardSearchRequestCore = { ...scorecardSearchRequestCore, ...filters }
      let scorecardSearchResult = await BEEScorecardService.getUserScorecardsCoreVA(scorecardSearchRequestCore);
      setOpenScorecardData(scorecardSearchResult.data.results);
      setFilteredItemsCount(scorecardSearchResult.data.filteredItemsCount);
      setTotalItemsCount(scorecardSearchResult.data.totalItemsCount);
    } catch (error) {
      setOpenScorecardData(defaultObject);
      setFilteredItemsCount(0);
      setTotalItemsCount(0);
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const scorecardLicensesFilterData: Array<IFilter> = [
    {
      label: "Scorecard Type:",
      values: beeScorecardType,
      type: FilterType.multiselect,
      propname: "scorecardTypeIds",
    },
    {
      label: "Is Consolidated:",
      values: [
        { key: "Yes", val: true },
        { key: "No", val: false },
      ],
      type: FilterType.select,
      propname: "isConsolidated",
    },
    {
      label: "User Name",
      values: userNames,
      type: FilterType.multiselect,
      propname: "createdByUserNames",
    },
    {
      label: "Year:",
      values: yearsRange,
      type: FilterType.multiselect,
      propname: "years",
    },
  ];

  const filtersChanged = async (filterProps: any) => {
    setPageNumber(1);
    let scorecardTypeIds = filterProps["scorecardTypeIds"];
    let years = filterProps["years"];
    let createdByUserName = filterProps["createdByUserNames"];
    let isConsolidated =
      filterProps["isConsolidated"].length == 0
        ? null
        : filterProps["isConsolidated"];
    setFilters({ ...filterProps, scorecardTypeIds, years, createdByUserName, isConsolidated })
  };

  useEffect(() => {
    getUsers();
    getScorecardType();
    getYearsRange();
  }, []);

  useEffect(() => {
    searchScorecardData();
  }, [entriesPerPage,
    pageNumber,
    columnSortOptions,
    searchValue,
    filters,
  ]);

  const handleAssignUser = (id: string) => {
    setSelectedScorecardId(id);
    setShowVaAssignModal(true);
  }

  const closeAssignUserModal = () => {
    setSelectedScorecardId("");
    setShowVaAssignModal(false);
  }


  const handleLockScorecard = async () => {
    try {
      await BEEScorecardService.lockScorecard(selectedScorecardId);
      toast.success("Successfully locked scorecard");
      searchScorecardData();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseLockModal();
    }
  }

  const handleCloseLockModal = () => {
    setShowLockConfirmationDialog(false);
  }

  const handleViewCertificates = (id: string) => {
    setShowViewCertificatesModal(true);
    setSelectedScorecardId(id);
  }

  const handleCloseViewCertificatesModal = () => {
    setShowViewCertificatesModal(false);
  }

  const handleStatusTracker = (id: string) => {
    setShowStatusTracker(true);
    setSelectedScorecardId(id);
  }

  const handleCloseStatusTracker = () => {
    setShowStatusTracker(false);
    searchScorecardData();
  }

  const confirmDeleteMessage = "Are you sure you want to delete this scorecard?";
  const confirmLockMessage = "Are you sure you want to lock this scorecard?";

  const showDeleteConfirmation = (id: string) => {
    setSelectedScorecardId(id);
    setShowDeleteConfirmationDialog(true);
  };

  const showLockConfirmation = (id: string) => {
    setSelectedScorecardId(id);
    setShowLockConfirmationDialog(true);
  };

  const openImportManagement = (scorecardId: string, scorecardName: string, scorecardTypeId: number ) => {
    setBBBEEScorecard({ scorecardId: scorecardId, scorecardName: scorecardName, scorecardTypeId: scorecardTypeId });
    history.push(`/bee/scorecard/${scorecardId}/fileManagement/uploaded`);
  }

  const openScorecardTableData = VAScorecardTableMapper(
    openScorecardsData,
    handleAssignUser,
    showLockConfirmation,
    showDeleteConfirmation,
    handleViewCertificates,
    handleStatusTracker,
    userRoles,
    openImportManagement
  );

  const handleAddScoredcard = () => {
    setShowModal(true);
  };

  const bulkActions = [
    {
      label: "Add Scorecard",
      action: handleAddScoredcard,
    },
  ];

  return (
    <>
      <DataTable
        table={openScorecardTableData}
        canSearch
        entriesPerPage={entriesPerPage}
        pageNumber={pageNumber}
        filteredItemsCount={filteredItemsCount}
        totalItemsCount={totalItemsCount}
        entriesPerPageChanged={entriesPerPageChanged}
        pageNumberChanged={pageNumberChanged}
        searchValueChanged={searchValueChanged}
        isLoading={isLoading}
        manualSorting={true}
        columnSortingChanged={columnSortingChanged}
        filters={scorecardLicensesFilterData}
        filtersChanged={filtersChanged}
        {...((userRoles.includes(ScorecardAdmin) || userRoles.includes(UserAdminRole)) ? { bulkActions } : {})}
      ></DataTable>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <CustomDialogTitle
          id="customized-dialog-title"
          onClose={() => setShowModal(false)}
        >
          Add Scorecard
        </CustomDialogTitle>
        <DialogContent>
          <ScorecardLicenseModal modalDescription={"Summary of Scorecard Licenses"} />
        </DialogContent>
      </Dialog>
      <ConfirmationDialog
        showDialog={showDeleteConfirmationDialog}
        handleAccept={handleDelete}
        handleCancel={handleCloseDeleteConfirmation}
        heading={"Confirm Delete"}
        message={confirmDeleteMessage}
      />
      <ConfirmationDialog
        showDialog={showLockConfirmationDialog}
        handleAccept={handleLockScorecard}
        handleCancel={handleCloseLockModal}
        heading={"Lock scorecard"}
        message={confirmLockMessage}
      />
      {showViewCertificatesModal && <VAClientCertificateModal showModal={showViewCertificatesModal} handleCancel={handleCloseViewCertificatesModal} scorecardId={selectedScorecardId} />}
      {showVAAssignModal && <AssignModal isOrganisationUserAccess={false} id={selectedScorecardId} showAssignModal={showVAAssignModal} closeAssignModal={closeAssignUserModal} />}
      <Dialog open={showVaModal} onClose={() => setVaShowModal(false)} aria-labelledby="form-dialog-title" maxWidth='xl'>
        <DialogContent>
          <ScorecardLicenseModal modalDescription={"Summary of Scorecard Licenses"} />
        </DialogContent>
      </Dialog>
      {showStatusTracker && <ScorecardVerificationProcessTracker scorecardId={selectedScorecardId} showScorecardVerificationProcessTrackerModal={showStatusTracker} closeScorecardVerificationProcessTrackerModal={handleCloseStatusTracker} />}
    </>
  );
}
